import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import endpoints from "../config/endpoints";
import { apiGet, apiPost } from "../utils/api_service";
const initialState = {
	stackholder: [],
	orderTo: [],
	documentForStakeHolder: [],
	stackholderName: [],
	stackholderNameFromType: [],
	area: [],
	orderToAdmin: "",
	stockStakeHolders: [],
	stockholderByArea: [],
	areaByBeatTaluka: [],
	areaByDistrictPost: [],
	opening: [],
	stockHolderByBeatIds: [],
	stockHolderByNoStructureWithOutletCount: [],
	creditLimit: {},
	salesDataByMonth: {},
	salesDataByDate: {},
	pendingBillsData: {},
	productList: {},
	stockHolderAnalytics: {},
	stockHolderOutletList: [],
	stockHolderOrderExistList: [],
};
let URL = endpoints.stackholder;
let URL1 = endpoints.stackholderDocument;
let URL2 = endpoints.document;
let URL3 = endpoints.stockStackHolderOpening;
let URL4 = endpoints.outletOpening;

const stakeHolderSlice = createSlice({
	name: "stackholder",
	initialState,
	reducers: {
		stakeHolderSuccess: (state = cloneDeep(initialState), action) => {
			const { row } = action.payload;
			return {
				...state,
				stackholder: row,
			};
		},

		creditLimitSuccess: (state = cloneDeep(initialState), action) => {
			const { row } = action.payload;
			return {
				...state,
				creditLimit: row,
			};
		},

		areaSuccess: (state = cloneDeep(initialState), action) => {
			const { row } = action.payload;
			return {
				...state,
				area: row,
			};
		},
		areaByDistrictPostSuccess: (state = cloneDeep(initialState), action) => {
			const { row } = action.payload;
			return {
				...state,
				areaByDistrictPost: row,
			};
		},
		areaByBeatTalukaSuccess: (state = cloneDeep(initialState), action) => {
			const { row } = action.payload;
			return {
				...state,
				areaByBeatTaluka: row,
			};
		},
		orderToSuccess: (state = cloneDeep(initialState), action) => {
			const { row, isAdmin } = action.payload;
			return {
				...state,
				orderTo: row,
				orderToAdmin: isAdmin,
			};
		},

		documentForStakeHolderSuccess: (
			state = cloneDeep(initialState),
			action,
		) => {
			const { row } = action.payload;
			return {
				...state,
				documentForStakeHolder: row,
			};
		},
		stakeHolderNameSuccess: (state = cloneDeep(initialState), action) => {
			const { row } = action.payload;
			return {
				...state,
				stackholderName: row,
			};
		},
		stakeHolderNameFromTypeSuccess: (
			state = cloneDeep(initialState),
			action,
		) => {
			const { row } = action.payload;
			return {
				...state,
				stackholderNameFromType: row,
			};
		},
		stockStakeHoldersSuccess: (state = cloneDeep(initialState), action) => {
			const { row } = action.payload;
			return {
				...state,
				stockStakeHolders: row,
			};
		},
		stockStakeHoldersByAreaSuccess: (
			state = cloneDeep(initialState),
			action,
		) => {
			const { row } = action.payload;
			return {
				...state,
				stockholderByArea: row,
			};
		},

		openingSuccess: (state = cloneDeep(initialState), action) => {
			const { row } = action.payload;
			return {
				...state,
				opening: row,
			};
		},

		stockHolderByBeatIdsSuccess: (state = cloneDeep(initialState), action) => {
			const { row } = action.payload;
			return {
				...state,
				stockHolderByBeatIds: row,
			};
		},

		stockHolderAnalyticsSuccess: (state = cloneDeep(initialState), action) => {
			const { row } = action.payload;
			return {
				...state,
				stockHolderAnalytics: row,
			};
		},

		stockHolderByNoStructureWithOutletCountSuccess: (
			state = cloneDeep(initialState),
			action,
		) => {
			const { row } = action.payload;
			return {
				...state,
				stockHolderByNoStructureWithOutletCount: row,
			};
		},
		salesDataByMonthSuccess: (state = cloneDeep(initialState), action) => {
			const { salesData } = action.payload;
			return {
				...state,
				salesDataByMonth: salesData,
			};
		},
		salesDataByDateSuccess: (state = cloneDeep(initialState), action) => {
			const { salesDataNew } = action.payload;
			return {
				...state,
				salesDataByDate: salesDataNew,
			};
		},
		pendingDataSuccess: (state = cloneDeep(initialState), action) => {
			const { row } = action.payload;
			return {
				...state,
				pendingBillsData: row,
			};
		},
		productListSuccess: (state = cloneDeep(initialState), action) => {
			const { row } = action.payload;
			return {
				...state,
				productList: row,
			};
		},

		stockHolderOutletSuccess: (state = cloneDeep(initialState), action) => {
			const { row } = action.payload;
			return {
				...state,
				stockHolderOutletList: row,
			};
		},

		stockHolderOrderExistSuccess: (state = cloneDeep(initialState), action) => {
			const { row } = action.payload;
			return {
				...state,
				stockHolderOrderExistList: row,
			};
		},
	},
});

export const {
	stakeHolderSuccess,
	resetState,
	orderToSuccess,
	documentForStakeHolderSuccess,
	stakeHolderNameSuccess,
	stakeHolderNameFromTypeSuccess,
	areaSuccess,
	creditLimitSuccess,
	areaByBeatTalukaSuccess,
	stockStakeHoldersSuccess,
	stockStakeHoldersByAreaSuccess,
	stockHolderStockIdsAndAreaIdsSuccess,
	areaByDistrictPostSuccess,
	openingSuccess,
	stockHolderByBeatIdsSuccess,
	stockHolderByNoStructureWithOutletCountSuccess,
	salesDataByMonthSuccess,
	salesDataByDateSuccess,
	pendingDataSuccess,
	productListSuccess,
	stockHolderAnalyticsSuccess,
	stockHolderOutletSuccess,
	stockHolderOrderExistSuccess,
} = stakeHolderSlice.actions;

export default stakeHolderSlice.reducer;

export const getStackHolder = () => async (dispatch) => {
	try {
		const response = apiGet({
			url: URL + '?sort={"insertDateTime": "DESC"}',
		}).then(({ data, success }) => {
			if (success) {
				const row = data.data.map((stakeholderData, index) => {
					let stakeholderObject = {
						index: index + 1,
						id: stakeholderData.id === null ? "" : stakeholderData.id,
						userName:
							stakeholderData.userName === null ? "" : stakeholderData.userName,
						firmName:
							stakeholderData.firmName === null ? "" : stakeholderData.firmName,
						ownerName:
							stakeholderData.ownerName === null
								? ""
								: stakeholderData.ownerName,
						orderTo:
							//stakeholderData.orderTo === null ? "" : stakeholderData.orderTo,
							stakeholderData.orderTo == null
								? ""
								: stakeholderData.orderTo == 0
									? "Admin"
									: "-",
						state:
							stakeholderData.state !== null && stakeholderData.state.id
								? stakeholderData.state.id
								: "",
						stateName:
							stakeholderData.state !== null && stakeholderData.state.name
								? stakeholderData.state.name
								: "",
						areaNames:
							stakeholderData.areaNames === null
								? ""
								: stakeholderData.areaNames,
						shCode:
							stakeholderData.shCode === null ? "" : stakeholderData.shCode,
						contactPersonName:
							stakeholderData.contactPersonName === null
								? ""
								: stakeholderData.contactPersonName,
						contactPersonNo:
							stakeholderData.contactPersonNo === null
								? ""
								: stakeholderData.contactPersonNo,
						emailId:
							stakeholderData.emailId === null ? "" : stakeholderData.emailId,
						stockStakeHolderTypeName:
							stakeholderData.stockStakeHolderType !== null &&
							stakeholderData.stockStakeHolderType.name !== null
								? stakeholderData.stockStakeHolderType.name
								: "",

						stockStakeHolderType:
							stakeholderData.stockStakeHolderType !== null &&
							stakeholderData.stockStakeHolderType.id
								? stakeholderData.stockStakeHolderType.id
								: "",

						isActive: stakeholderData.isActive,

						address:
							stakeholderData.address === null ? "" : stakeholderData.address,

						region:
							stakeholderData.region !== null && stakeholderData.region.id
								? stakeholderData.region.id
								: "",
						regionName:
							stakeholderData.region !== null && stakeholderData.region.name
								? stakeholderData.region.name
								: "",

						zoneIds:
							stakeholderData.zoneIds === null ? "" : stakeholderData.zoneIds,

						areaIds:
							stakeholderData.areaIds === null ? "" : stakeholderData.areaIds,
					};
					return stakeholderObject;
				});
				dispatch(stakeHolderSuccess({ row }));
				return { response: row, success };
			}
			return { response: [], success };
		});
		return response;
	} catch (e) {
		return console.error(e.message);
	}
};

export const getStockHolderBySalesTeamId =
	({ salesTeamId }) =>
	async (dispatch) => {
		try {
			const response = await apiGet({
				url: URL + "/by-sales-team?salesTeamId=" + salesTeamId,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((stakeholderData, index) => {
						let stakeholderObject = {
							index: index + 1,
							id: stakeholderData.id === null ? "" : stakeholderData.id,
							userName:
								stakeholderData.userName === null
									? ""
									: stakeholderData.userName,
							firmName:
								stakeholderData.firmName === null
									? ""
									: stakeholderData.firmName,
							ownerName:
								stakeholderData.ownerName === null
									? ""
									: stakeholderData.ownerName,
							name:
								stakeholderData.firmName !== null &&
								stakeholderData.stockStakeHolderTypePrefix !== null
									? stakeholderData.firmName +
										" (" +
										stakeholderData.stockStakeHolderTypePrefix +
										")"
									: "",
							stockStakeHolderTypeId:
								stakeholderData.stockStakeHolderTypeId === null
									? ""
									: stakeholderData.stockStakeHolderTypeId,
							stockStakeHolderTypeName:
								stakeholderData.stockStakeHolderTypeName === null
									? ""
									: stakeholderData.stockStakeHolderTypeName,
							stockStakeHolderTypePrefix:
								stakeholderData.stockStakeHolderTypePrefix === null
									? ""
									: stakeholderData.stockStakeHolderTypePrefix,
						};
						return stakeholderObject;
					});
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getUpdatedStackHolder = () => async (dispatch) => {
	try {
		const response = apiGet({
			// http://localhost:8088/api/distribution/v1/stock-stake-holder/find-all
			url: URL + '/find-all?sort={"insertDateTime": "DESC"}',
		}).then(({ data, success }) => {
			if (success) {
				const row = data.data.map((stakeholderData, index) => {
					let stakeholderObject = {
						index: index + 1,
						id: stakeholderData.id === null ? "" : stakeholderData.id,
						userName:
							stakeholderData.userName === null ? "" : stakeholderData.userName,
						firmName:
							stakeholderData.firmName === null ? "" : stakeholderData.firmName,
						firmNameWithType:
							stakeholderData.firmName !== null &&
							stakeholderData.stockStakeHolderTypeName !== null
								? stakeholderData.firmName +
									" (" +
									stakeholderData.stockStakeHolderTypeName +
									")"
								: "",
						ownerName:
							stakeholderData.ownerName === null
								? ""
								: stakeholderData.ownerName,
						orderTo:
							//stakeholderData.orderTo === null ? "" : stakeholderData.orderTo,
							stakeholderData.orderTo == null
								? ""
								: stakeholderData.orderTo == 0
									? "Admin"
									: "-",
						orderToName:
							stakeholderData.orderToName !== null
								? stakeholderData.orderToName
								: "",
						state:
							stakeholderData.stateId !== null ? stakeholderData.stateId : "",
						stateName:
							stakeholderData.stateName !== null
								? stakeholderData.stateName
								: "",
						areaNames:
							stakeholderData.areaNames && stakeholderData.areaNames === null
								? ""
								: stakeholderData.areaNames,
						shCode:
							stakeholderData.shCode === null ? "" : stakeholderData.shCode,
						contactPersonName:
							stakeholderData.contactPersonName === null
								? ""
								: stakeholderData.contactPersonName,
						contactPersonNo:
							stakeholderData.contactPersonNo === null
								? ""
								: stakeholderData.contactPersonNo,
						emailId:
							stakeholderData.emailId === null ? "" : stakeholderData.emailId,
						stockStakeHolderTypeName:
							stakeholderData.stockStakeHolderTypeName !== null
								? stakeholderData.stockStakeHolderTypeName
								: "",

						stockStakeHolderType:
							stakeholderData.stockStakeHolderTypeId !== null
								? stakeholderData.stockStakeHolderTypeId
								: "",

						isActive: stakeholderData.isActive,

						address:
							stakeholderData.address === null ? "" : stakeholderData.address,

						region:
							stakeholderData.regionId !== null ? stakeholderData.regionId : "",
						regionName:
							stakeholderData.regionName !== null
								? stakeholderData.regionName
								: "",

						zoneIds:
							stakeholderData.zoneIds === null ? "" : stakeholderData.zoneIds,

						areaIds:
							stakeholderData.areaIds === null ? "" : stakeholderData.areaIds,
					};
					return stakeholderObject;
				});
				dispatch(stakeHolderSuccess({ row }));
				return { response: row, success };
			}
			return { response: [], success };
		});
		return response;
	} catch (e) {
		return console.error(e.message);
	}
};

export const getUpdatedStackHolderOptimized = () => async (dispatch) => {
	try {
		const response = apiGet({
			url: URL + "/find-all-optimize",
		}).then(({ data, success }) => {
			if (success) {
				const row = data.data.map((stakeholderData, index) => {
					let stakeholderObject = {
						index: index + 1,
						id: stakeholderData.id === null ? "" : stakeholderData.id,
						userName:
							stakeholderData.userName === null ? "" : stakeholderData.userName,
						firmName:
							stakeholderData.firmName === null ? "" : stakeholderData.firmName,
						firmNameWithType:
							stakeholderData.firmName !== null &&
							stakeholderData.stockStakeHolderTypeName !== null
								? stakeholderData.firmName +
									" (" +
									stakeholderData.stockStakeHolderTypeName +
									")"
								: "",
						ownerName:
							stakeholderData.ownerName === null
								? ""
								: stakeholderData.ownerName,
						orderToName:
							stakeholderData.orderTo == null ? "" : stakeholderData.orderTo,
						stateName:
							stakeholderData.stateName === null
								? ""
								: stakeholderData.stateName,
						areaNames:
							stakeholderData.areaNames === null
								? ""
								: stakeholderData.areaNames,
						shCode:
							stakeholderData.shCode === null ? "" : stakeholderData.shCode,
						contactPersonName:
							stakeholderData.contactPersonName === null
								? ""
								: stakeholderData.contactPersonName,
						contactPersonNo:
							stakeholderData.contactPersonNo !== null
								? stakeholderData.contactPersonNo
								: "",
						emailId:
							stakeholderData.emailId === null ? "" : stakeholderData.emailId,
						stockStakeHolderTypeName:
							stakeholderData.stockStakeHolderTypeName !== null
								? stakeholderData.stockStakeHolderTypeName
								: "",
						isActive:
							stakeholderData.isActive === null ? "" : stakeholderData.isActive,
					};
					return stakeholderObject;
				});
				dispatch(stakeHolderSuccess({ row }));
				return { response: row, success };
			}
			return { response: [], success };
		});
		return response;
	} catch (e) {
		return console.error(e.message);
	}
};

export const getOrderToList =
	({ StockStakeHolderTypeId, areaIds }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url:
					URL +
					"/order-to-list?StockStakeHolderTypeId=" +
					StockStakeHolderTypeId +
					"&areaIds=" +
					areaIds,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.stockStakeHolders.map((orderToData, index) => {
						let orderToObject = {
							index: index + 1,
							id: orderToData.id === null ? "" : orderToData.id,
							userId: orderToData.userId === null ? "" : orderToData.userId,
							userName:
								orderToData.userName === null ? "" : orderToData.userName,
							name: orderToData.ownerName === null ? "" : orderToData.ownerName,
							stockStakeHolderTypeId:
								orderToData.stockStakeHolderType === null
									? ""
									: orderToData.stockStakeHolderType.id,
							stockStakeHolderTypeName:
								orderToData.stockStakeHolderType === null
									? ""
									: orderToData.stockStakeHolderType.name,
							userType:
								orderToData.stockStakeHolderType === null
									? ""
									: orderToData.stockStakeHolderType.userType.name,
							ownerName:
								orderToData.ownerName === null ? "" : orderToData.ownerName,
							firmName:
								orderToData.firmName === null ? "" : orderToData.firmName,
							contactPersonName:
								orderToData.contactPersonName === null
									? ""
									: orderToData.contactPersonName,
							contactPersonNo:
								orderToData.contactPersonNo === null
									? ""
									: orderToData.contactPersonNo,

							orderTo: orderToData.orderTo === null ? "" : orderToData.orderTo,
							region: orderToData.region === null ? "" : orderToData.region,
							stockStakeHolderType:
								orderToData.stockStakeHolderType === null
									? ""
									: orderToData.stockStakeHolderType,
						};
						return orderToObject;
					});
					dispatch(orderToSuccess({ row, isAdmin: data.data.flag }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getOrderToListPost =
	({ jsonData }) =>
	async (dispatch) => {
		try {
			const response = apiPost({
				url: URL + "/order-to-list",
				postBody: jsonData,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.stockStakeHolders.map((orderToData, index) => {
						let orderToObject = {
							index: index + 1,
							id: orderToData.id === null ? "" : orderToData.id,
							userId: orderToData.userId === null ? "" : orderToData.userId,
							userName:
								orderToData.userName === null ? "" : orderToData.userName,
							name:
								orderToData.firmName !== null &&
								orderToData.stockStakeHolderType !== null &&
								orderToData.stockStakeHolderType.name !== null
									? orderToData.firmName +
										" (" +
										orderToData.stockStakeHolderType.name +
										")"
									: "",
							stockStakeHolderTypeId:
								orderToData.stockStakeHolderType === null
									? ""
									: orderToData.stockStakeHolderType.id,
							stockStakeHolderTypeName:
								orderToData.stockStakeHolderType === null
									? ""
									: orderToData.stockStakeHolderType.name,
							userType:
								orderToData.stockStakeHolderType === null
									? ""
									: orderToData.stockStakeHolderType.userType.name,
							ownerName:
								orderToData.ownerName === null ? "" : orderToData.ownerName,
							firmName:
								orderToData.firmName === null ? "" : orderToData.firmName,
							contactPersonName:
								orderToData.contactPersonName === null
									? ""
									: orderToData.contactPersonName,
							contactPersonNo:
								orderToData.contactPersonNo === null
									? ""
									: orderToData.contactPersonNo,

							orderTo: orderToData.orderTo === null ? "" : orderToData.orderTo,
							region: orderToData.region === null ? "" : orderToData.region,
							stockStakeHolderType:
								orderToData.stockStakeHolderType === null
									? ""
									: orderToData.stockStakeHolderType,
						};
						return orderToObject;
					});
					dispatch(orderToSuccess({ row, isAdmin: data.data.flag }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const setStakeDocList =
	({ row }) =>
	async (dispatch) => {
		dispatch(documentForStakeHolderSuccess({ row }));
	};

export const getDocumentForStakeHolder =
	({ docList, type }) =>
	async (dispatch) => {
		try {
			console.log(docList);
			const response = apiGet({
				url: URL2 + "/by-type?type=" + type,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((stakeholderData, index) => {
						let stakeholderObject = {
							index: index + 1,
							id: stakeholderData.id === null ? "" : stakeholderData.id,
							documentName:
								stakeholderData.docName === null ? "" : stakeholderData.docName,
							type: stakeholderData.type === null ? "" : stakeholderData.type,
							imagePath: "",
							imagePathToSave:
								stakeholderData.fileName === null
									? ""
									: stakeholderData.fileName,
							insertDateTime:
								stakeholderData.insertDateTime === null
									? ""
									: stakeholderData.insertDateTime,
						};
						return stakeholderObject;
					});
					dispatch(documentForStakeHolderSuccess({ row }));
					return { response: [], success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return { response: [], success: false };
		}
	};
export const getStakeHolderName =
	({ StockStakeHolderTypeIds }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url:
					URL +
					"/by-stock-stake-holder-types?StockStakeHolderTypeIds=" +
					StockStakeHolderTypeIds,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((stakeHolderTypeObj) => {
						const stakeHolderTypeData = {
							...stakeHolderTypeObj,
							name:
								stakeHolderTypeObj.ownerName !== null &&
								stakeHolderTypeObj.ownerName
									? stakeHolderTypeObj.ownerName
									: "",
						};
						return stakeHolderTypeData;
					});
					dispatch(stakeHolderNameSuccess({ row: row }));
					return { response: [], success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getAreaByStockStakeHolderTypeIdAndZoneIds =
	({ StockStakeHolderTypeId, zoneIds }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url:
					URL +
					"/get-areas?StockStakeHolderTypeId=" +
					StockStakeHolderTypeId +
					"&zoneIds=" +
					zoneIds,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((areaObject, index) => {
						let areaData = {
							index: index + 1,
							id: areaObject.id === null ? "" : areaObject.id,
							name:
								areaObject.name === null
									? ""
									: areaObject.name + " (" + areaObject.shortName + ")",
							zoneName:
								areaObject.taluka !== null &&
								areaObject.taluka.district.zone.name
									? areaObject.taluka.district.zone.name
									: "",
							zone:
								areaObject.taluka !== null && areaObject.taluka.district.zone.id
									? areaObject.taluka.district.zone.id
									: "",
							shortName:
								areaObject.shortName === null ? "" : areaObject.shortName,
							sortOrder:
								areaObject.sortOrder === null ? "" : areaObject.sortOrder,
						};
						return areaData;
					});
					dispatch(areaSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getAreaByStockStakeHolderTypeZoneAndTaluka =
	({ StockStakeHolderTypeId, zoneIds, talukaIds }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url:
					URL +
					"/get-areas-by-zones-talukas?StockStakeHolderTypeId=" +
					StockStakeHolderTypeId +
					"&zoneIds=" +
					zoneIds +
					"&talukaIds=" +
					talukaIds,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((areaObject, index) => {
						let areaData = {
							index: index + 1,
							id: areaObject.id === null ? "" : areaObject.id,
							name:
								areaObject.name === null
									? ""
									: areaObject.name + " (" + areaObject.shortName + ")",
							zoneName:
								areaObject.taluka !== null &&
								areaObject.taluka.district.zone.name
									? areaObject.taluka.district.zone.name
									: "",
							zone:
								areaObject.taluka !== null && areaObject.taluka.district.zone.id
									? areaObject.taluka.district.zone.id
									: "",
							talukaId:
								areaObject.taluka !== null && areaObject.taluka.id !== null
									? areaObject.taluka.id
									: "",
							shortName:
								areaObject.shortName === null ? "" : areaObject.shortName,
							sortOrder:
								areaObject.sortOrder === null ? "" : areaObject.sortOrder,
						};
						return areaData;
					});
					dispatch(areaByBeatTalukaSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};
export const getAreaByStockStakeHolderTypeIdAndZoneIdsEdit =
	({ saleExcId, StockStakeHolderTypeId, zoneIds }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url:
					URL +
					"/" +
					saleExcId +
					"/get-areas-on-edit?StockStakeHolderTypeId=" +
					StockStakeHolderTypeId +
					"&zoneIds=" +
					zoneIds,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((areaObject, index) => {
						let areaData = {
							index: index + 1,
							id: areaObject.id === null ? "" : areaObject.id,
							name:
								areaObject.name === null
									? ""
									: areaObject.name + " (" + areaObject.shortName + ")",
							taluka: areaObject.taluka === null ? "" : areaObject.taluka,
							talukaId:
								areaObject.taluka !== null && areaObject.taluka.id !== null
									? areaObject.taluka.id
									: "",
							zone:
								areaObject.taluka !== null &&
								areaObject.taluka.district !== null &&
								areaObject.taluka.district.zone !== null &&
								areaObject.taluka.district.zone.id
									? areaObject.taluka.district.zone.id
									: "",
							zoneName:
								areaObject.taluka !== null &&
								areaObject.taluka.district !== null &&
								areaObject.taluka.district.zone !== null &&
								areaObject.taluka.district.zone.name
									? areaObject.taluka.district.zone.name
									: "",

							shortName:
								areaObject.shortName === null ? "" : areaObject.shortName,
							sortOrder:
								areaObject.sortOrder === null ? "" : areaObject.sortOrder,
						};
						return areaData;
					});
					dispatch(areaSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getStockStackHolders = () => async (dispatch) => {
	try {
		const response = apiGet({
			url: URL + "/holders",
		}).then(({ data, success }) => {
			if (success) {
				const row = data.data.map((stakeholdersData, index) => {
					let stakeholdersObject = {
						index: index + 1,
						id: stakeholdersData.id === null ? "" : stakeholdersData.id,
						userId:
							stakeholdersData.userId === null ? "" : stakeholdersData.userId,
						userName:
							stakeholdersData.userName === null
								? ""
								: stakeholdersData.userName,
						stockStakeHolderType:
							stakeholdersData.stockStakeHolderType === null
								? ""
								: stakeholdersData.stockStakeHolderType,
						name:
							stakeholdersData.ownerName === null &&
							stakeholdersData.firmName === null
								? ""
								: stakeholdersData.firmName +
									" - " +
									stakeholdersData.ownerName,
						ownerName:
							stakeholdersData.ownerName === null
								? ""
								: stakeholdersData.ownerName,
						firmName:
							stakeholdersData.firmName === null
								? ""
								: stakeholdersData.firmName,
						contactPersonName:
							stakeholdersData.contactPersonName === null
								? ""
								: stakeholdersData.contactPersonName,
						contactPersonNo:
							stakeholdersData.contactPersonNo === null
								? ""
								: stakeholdersData.contactPersonNo,
						address:
							stakeholdersData.address === null ? "" : stakeholdersData.address,
						state:
							stakeholdersData.state === null
								? ""
								: stakeholdersData.state.name,
						stateCode:
							stakeholdersData.state === null
								? ""
								: stakeholdersData.state.code,
						emailId:
							stakeholdersData.emailId === null ? "" : stakeholdersData.emailId,
						gstNo:
							stakeholdersData.gstNo === null ? "" : stakeholdersData.gstNo,

						panNo:
							stakeholdersData.panNo === null ? "" : stakeholdersData.panNo,
						orderTo:
							stakeholdersData.orderTo === null ? "" : stakeholdersData.orderTo,
						region:
							stakeholdersData.region === null ? "" : stakeholdersData.region,
						zoneIds:
							stakeholdersData.zoneIds === null ? "" : stakeholdersData.zoneIds,
						areaIds:
							stakeholdersData.areaIds === null ? "" : stakeholdersData.areaIds,
						accessRoleId:
							stakeholdersData.accessRoleId === null
								? ""
								: stakeholdersData.accessRoleId,
						stockStakeHolder:
							stakeholdersData.stockStakeHolder === null
								? ""
								: stakeholdersData.stockStakeHolder,

						isActive: stakeholdersData.isActive,
					};
					return stakeholdersObject;
				});
				dispatch(stockStakeHoldersSuccess({ row }));
				return { response: row, success };
			}
			return { response: [], success };
		});
		return response;
	} catch (e) {
		return console.error(e.message);
	}
};

export const getStockStakeHolderOrderTo = () => async (dispatch) => {
	try {
		const response = apiGet({
			url: URL + "/get-to-order",
		}).then(({ data, success }) => {
			if (success) {
				const row = data.data.map((stakeholderData, index) => {
					let stakeholderObject = {
						index: index + 1,
						id: stakeholderData.id === null ? "" : stakeholderData.id,
						userName:
							stakeholderData.userName === null ? "" : stakeholderData.userName,
						firmName:
							stakeholderData.firmName === null ? "" : stakeholderData.firmName,
						ownerName:
							stakeholderData.ownerName === null
								? ""
								: stakeholderData.ownerName,
						contactPersonName:
							stakeholderData.contactPersonName === null
								? ""
								: stakeholderData.contactPersonName,
						contactPersonNo:
							stakeholderData.contactPersonNo === null
								? ""
								: stakeholderData.contactPersonNo,
						address:
							stakeholderData.address === null ? "" : stakeholderData.address,
						emailId:
							stakeholderData.emailId === null ? "" : stakeholderData.emailId,
						stockStakeHolderTypeName:
							stakeholderData.stockStakeHolderType !== null &&
							stakeholderData.stockStakeHolderType.name !== null
								? stakeholderData.stockStakeHolderType.name
								: "",

						stockStakeHolderType:
							stakeholderData.stockStakeHolderType !== null &&
							stakeholderData.stockStakeHolderType.id
								? stakeholderData.stockStakeHolderType.id
								: "",
						orderTo:
							stakeholderData.orderTo === null ? "" : stakeholderData.orderTo,
						region:
							stakeholderData.region !== null && stakeholderData.region.id
								? stakeholderData.region.id
								: "",
						regionName:
							stakeholderData.region !== null && stakeholderData.region.name
								? stakeholderData.region.name
								: "",
						zoneIds:
							stakeholderData.zoneIds === null ? "" : stakeholderData.zoneIds,

						areaIds:
							stakeholderData.areaIds === null ? "" : stakeholderData.areaIds,

						isActive: stakeholderData.isActive,
					};
					return stakeholderObject;
				});
				dispatch(stakeHolderSuccess({ row }));
				return { response: row, success };
			}
			return { response: [], success };
		});
		return response;
	} catch (e) {
		return console.error(e.message);
	}
};

export const getStockholderByUser = () => async (dispatch) => {
	try {
		const response = apiGet({
			url: URL + "/by-user-areas",
		}).then(({ data, success }) => {
			if (success) {
				const row = data.data.map((stakeholderByUserData, index) => {
					let stakeholderByUserAreaObject = {
						index: index + 1,
						id:
							stakeholderByUserData.id === null ? "" : stakeholderByUserData.id,
						userName:
							stakeholderByUserData.userName === null
								? ""
								: stakeholderByUserData.userName,
						firmName:
							stakeholderByUserData.firmName === null
								? ""
								: stakeholderByUserData.firmName,
						ownerName:
							stakeholderByUserData.ownerName === null
								? ""
								: stakeholderByUserData.ownerName,
						name:
							stakeholderByUserData.ownerName === null &&
							stakeholderByUserData.firmName === null
								? ""
								: stakeholderByUserData.firmName +
									" - " +
									stakeholderByUserData.ownerName,
						orderToOwnerName:
							stakeholderByUserData.orderToOwnerName === null
								? ""
								: stakeholderByUserData.orderToOwnerName,
						state:
							stakeholderByUserData.state !== null &&
							stakeholderByUserData.state.id
								? stakeholderByUserData.state.id
								: "",
						stateName:
							stakeholderByUserData.state !== null &&
							stakeholderByUserData.state.name
								? stakeholderByUserData.state.name
								: "",
						areaNames:
							stakeholderByUserData.areaNames === null
								? ""
								: stakeholderByUserData.areaNames,
						contactPersonName:
							stakeholderByUserData.contactPersonName === null
								? ""
								: stakeholderByUserData.contactPersonName,
						contactPersonNo:
							stakeholderByUserData.contactPersonNo === null
								? ""
								: stakeholderByUserData.contactPersonNo,
						address:
							stakeholderByUserData.address === null
								? ""
								: stakeholderByUserData.address,
						emailId:
							stakeholderByUserData.emailId === null
								? ""
								: stakeholderByUserData.emailId,
						stockStakeHolderTypeName:
							stakeholderByUserData.stockStakeHolderType !== null &&
							stakeholderByUserData.stockStakeHolderType.name !== null
								? stakeholderByUserData.stockStakeHolderType.name
								: "",

						stockStakeHolderType:
							stakeholderByUserData.stockStakeHolderType !== null &&
							stakeholderByUserData.stockStakeHolderType.id
								? stakeholderByUserData.stockStakeHolderType.id
								: "",

						region:
							stakeholderByUserData.region !== null &&
							stakeholderByUserData.region.id
								? stakeholderByUserData.region.id
								: "",
						regionName:
							stakeholderByUserData.region !== null &&
							stakeholderByUserData.region.name
								? stakeholderByUserData.region.name
								: "",

						zoneIds:
							stakeholderByUserData.zoneIds === null
								? ""
								: stakeholderByUserData.zoneIds,

						areaIds:
							stakeholderByUserData.areaIds === null
								? ""
								: stakeholderByUserData.areaIds,

						isActive: stakeholderByUserData.isActive,
					};
					return stakeholderByUserAreaObject;
				});
				dispatch(stockStakeHoldersSuccess({ row }));
				return { response: row, success };
			}
			return { response: [], success };
		});
		return response;
	} catch (e) {
		return console.error(e.message);
	}
};

export const getStockholderByUserRegion = () => async (dispatch) => {
	try {
		const response = apiGet({
			url: URL + "/by-user-regions",
		}).then(({ data, success }) => {
			if (success) {
				const row = data.data.map((stakeholderByUserData, index) => {
					let stakeholderByUserAreaObject = {
						index: index + 1,
						id:
							stakeholderByUserData.id === null ? "" : stakeholderByUserData.id,
						userName:
							stakeholderByUserData.userName === null
								? ""
								: stakeholderByUserData.userName,
						firmName:
							stakeholderByUserData.firmName === null
								? ""
								: stakeholderByUserData.firmName,
						ownerName:
							stakeholderByUserData.ownerName === null
								? ""
								: stakeholderByUserData.ownerName,

						orderToOwnerName:
							stakeholderByUserData.orderToOwnerName === null
								? ""
								: stakeholderByUserData.orderToOwnerName,
						state:
							stakeholderByUserData.state !== null &&
							stakeholderByUserData.state.id
								? stakeholderByUserData.state.id
								: "",
						stateName:
							stakeholderByUserData.state !== null &&
							stakeholderByUserData.state.name
								? stakeholderByUserData.state.name
								: "",

						brandName:
							stakeholderByUserData.brand !== null &&
							stakeholderByUserData.brand.name
								? stakeholderByUserData.brand.name
								: "",

						name:
							stakeholderByUserData.ownerName === null &&
							stakeholderByUserData.firmName === null
								? ""
								: stakeholderByUserData.firmName +
									" - " +
									stakeholderByUserData.ownerName,

						areaNames:
							stakeholderByUserData.areaNames === null
								? ""
								: stakeholderByUserData.areaNames,
						contactPersonName:
							stakeholderByUserData.contactPersonName === null
								? ""
								: stakeholderByUserData.contactPersonName,
						contactPersonNo:
							stakeholderByUserData.contactPersonNo === null
								? ""
								: stakeholderByUserData.contactPersonNo,
						address:
							stakeholderByUserData.address === null
								? ""
								: stakeholderByUserData.address,
						emailId:
							stakeholderByUserData.emailId === null
								? ""
								: stakeholderByUserData.emailId,
						stockStakeHolderTypeName:
							stakeholderByUserData.stockStakeHolderType !== null &&
							stakeholderByUserData.stockStakeHolderType.name !== null
								? stakeholderByUserData.stockStakeHolderType.name
								: "",

						stockStakeHolderType:
							stakeholderByUserData.stockStakeHolderType !== null &&
							stakeholderByUserData.stockStakeHolderType.id
								? stakeholderByUserData.stockStakeHolderType.id
								: "",

						region:
							stakeholderByUserData.region !== null &&
							stakeholderByUserData.region.id
								? stakeholderByUserData.region.id
								: "",
						regionName:
							stakeholderByUserData.region !== null &&
							stakeholderByUserData.region.name
								? stakeholderByUserData.region.name
								: "",

						zoneIds:
							stakeholderByUserData.zoneIds === null
								? ""
								: stakeholderByUserData.zoneIds,

						areaIds:
							stakeholderByUserData.areaIds === null
								? ""
								: stakeholderByUserData.areaIds,

						isActive: stakeholderByUserData.isActive,
						isChecked: false,
					};
					return stakeholderByUserAreaObject;
				});
				dispatch(stockStakeHoldersSuccess({ row }));
				return { response: row, success };
			}
			return { response: [], success };
		});
		return response;
	} catch (e) {
		return console.error(e.message);
	}
};

export const getStockholderByUserArea = () => async (dispatch) => {
	try {
		const response = apiGet({
			url: URL + "/get-active-by-user-areas",
		}).then(({ data, success }) => {
			if (success) {
				const row = data.data.map((stakeholderByUserData, index) => {
					let stakeholderByUserAreaObject = {
						index: index + 1,
						id:
							stakeholderByUserData.id === null ? "" : stakeholderByUserData.id,
						userName:
							stakeholderByUserData.userName === null
								? ""
								: stakeholderByUserData.userName,
						firmName:
							stakeholderByUserData.firmName === null
								? ""
								: stakeholderByUserData.firmName,
						ownerName:
							stakeholderByUserData.ownerName === null
								? ""
								: stakeholderByUserData.ownerName,

						orderToOwnerName:
							stakeholderByUserData.orderToOwnerName === null
								? ""
								: stakeholderByUserData.orderToOwnerName,
						state:
							stakeholderByUserData.state !== null &&
							stakeholderByUserData.state.id
								? stakeholderByUserData.state.id
								: "",
						stateName:
							stakeholderByUserData.state !== null &&
							stakeholderByUserData.state.name
								? stakeholderByUserData.state.name
								: "",

						brandName:
							stakeholderByUserData.brand !== null &&
							stakeholderByUserData.brand.name
								? stakeholderByUserData.brand.name
								: "",

						name:
							stakeholderByUserData.ownerName === null &&
							stakeholderByUserData.firmName === null
								? ""
								: stakeholderByUserData.firmName +
									" - " +
									stakeholderByUserData.ownerName,

						areaNames:
							stakeholderByUserData.areaNames === null
								? ""
								: stakeholderByUserData.areaNames,
						contactPersonName:
							stakeholderByUserData.contactPersonName === null
								? ""
								: stakeholderByUserData.contactPersonName,
						contactPersonNo:
							stakeholderByUserData.contactPersonNo === null
								? ""
								: stakeholderByUserData.contactPersonNo,
						address:
							stakeholderByUserData.address === null
								? ""
								: stakeholderByUserData.address,
						emailId:
							stakeholderByUserData.emailId === null
								? ""
								: stakeholderByUserData.emailId,
						stockStakeHolderTypeName:
							stakeholderByUserData.stockStakeHolderType !== null &&
							stakeholderByUserData.stockStakeHolderType.name !== null
								? stakeholderByUserData.stockStakeHolderType.name
								: "",

						stockStakeHolderType:
							stakeholderByUserData.stockStakeHolderType !== null &&
							stakeholderByUserData.stockStakeHolderType.id
								? stakeholderByUserData.stockStakeHolderType.id
								: "",

						region:
							stakeholderByUserData.region !== null &&
							stakeholderByUserData.region.id
								? stakeholderByUserData.region.id
								: "",
						regionName:
							stakeholderByUserData.region !== null &&
							stakeholderByUserData.region.name
								? stakeholderByUserData.region.name
								: "",

						zoneIds:
							stakeholderByUserData.zoneIds === null
								? ""
								: stakeholderByUserData.zoneIds,

						areaIds:
							stakeholderByUserData.areaIds === null
								? ""
								: stakeholderByUserData.areaIds,

						isActive: stakeholderByUserData.isActive,
						isChecked: false,
					};
					return stakeholderByUserAreaObject;
				});
				dispatch(stockStakeHoldersSuccess({ row }));
				return { response: row, success };
			}
			return { response: [], success };
		});
		return response;
	} catch (e) {
		return console.error(e.message);
	}
};

export const getStockholderByAreaIds =
	({ areaIds }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url: URL + "/by-areas?areaIds=" + areaIds,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((stakeholderData, index) => {
						let stakeholderByAreaObject = {
							index: index + 1,
							id: stakeholderData.id === null ? "" : stakeholderData.id,
							userName:
								stakeholderData.userName === null
									? ""
									: stakeholderData.userName,
							firmName:
								stakeholderData.firmName === null
									? ""
									: stakeholderData.firmName,
							ownerName:
								stakeholderData.ownerName === null
									? ""
									: stakeholderData.ownerName,
							orderToOwnerName:
								stakeholderData.orderToOwnerName === null
									? ""
									: stakeholderData.orderToOwnerName,
							state:
								stakeholderData.state !== null && stakeholderData.state.id
									? stakeholderData.state.id
									: "",
							stateName:
								stakeholderData.state !== null && stakeholderData.state.name
									? stakeholderData.state.name
									: "",
							areaNames:
								stakeholderData.areaNames === null
									? ""
									: stakeholderData.areaNames,
							name:
								stakeholderData.contactPersonName === null
									? ""
									: stakeholderData.contactPersonName,
							shCode:
								stakeholderData.shCode === null ? "" : stakeholderData.shCode,
							contactPersonName:
								stakeholderData.contactPersonName === null
									? ""
									: stakeholderData.contactPersonName,
							contactPersonNo:
								stakeholderData.contactPersonNo === null
									? ""
									: stakeholderData.contactPersonNo,
							address:
								stakeholderData.address === null ? "" : stakeholderData.address,
							emailId:
								stakeholderData.emailId === null ? "" : stakeholderData.emailId,
							stockStakeHolderTypeName:
								stakeholderData.stockStakeHolderType !== null &&
								stakeholderData.stockStakeHolderType.name !== null
									? stakeholderData.stockStakeHolderType.name
									: "",

							stockStakeHolderType:
								stakeholderData.stockStakeHolderType !== null &&
								stakeholderData.stockStakeHolderType.id
									? stakeholderData.stockStakeHolderType.id
									: "",

							region:
								stakeholderData.region !== null && stakeholderData.region.id
									? stakeholderData.region.id
									: "",
							regionName:
								stakeholderData.region !== null && stakeholderData.region.name
									? stakeholderData.region.name
									: "",

							zoneIds:
								stakeholderData.zoneIds === null ? "" : stakeholderData.zoneIds,

							areaIds:
								stakeholderData.areaIds === null ? "" : stakeholderData.areaIds,

							isActive: stakeholderData.isActive,
						};
						return stakeholderByAreaObject;
					});
					dispatch(stockStakeHoldersByAreaSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};
export const getStockholderByAreaIdsForFilter =
	({ areaIds }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url: URL + "/by-areas?areaIds=" + areaIds,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((stakeholderData, index) => {
						let stakeholderByAreaObject = {
							index: index + 1,
							id: stakeholderData.id === null ? "" : stakeholderData.id,
							userName:
								stakeholderData.userName === null
									? ""
									: stakeholderData.userName,
							name:
								stakeholderData.firmName !== null &&
								stakeholderData.stockStakeHolderType !== null
									? stakeholderData.firmName +
										" (" +
										stakeholderData.stockStakeHolderType.prefix +
										")"
									: "",
							firmName:
								stakeholderData.firmName === null
									? ""
									: stakeholderData.firmName,
							ownerName:
								stakeholderData.ownerName === null
									? ""
									: stakeholderData.ownerName,
							orderTo:
								//stakeholderData.orderTo === null ? "" : stakeholderData.orderTo,
								stakeholderData.orderTo == null
									? ""
									: stakeholderData.orderTo == 0
										? "Admin"
										: "-",
							state:
								stakeholderData.state !== null && stakeholderData.state.id
									? stakeholderData.state.id
									: "",
							stateName:
								stakeholderData.state !== null && stakeholderData.state.name
									? stakeholderData.state.name
									: "",
							areaNames:
								stakeholderData.areaNames === null
									? ""
									: stakeholderData.areaNames,
							shCode:
								stakeholderData.shCode === null ? "" : stakeholderData.shCode,
							contactPersonName:
								stakeholderData.contactPersonName === null
									? ""
									: stakeholderData.contactPersonName,
							contactPersonNo:
								stakeholderData.contactPersonNo === null
									? ""
									: stakeholderData.contactPersonNo,
							emailId:
								stakeholderData.emailId === null ? "" : stakeholderData.emailId,
							stockStakeHolderTypeName:
								stakeholderData.stockStakeHolderType !== null &&
								stakeholderData.stockStakeHolderType.name !== null
									? stakeholderData.stockStakeHolderType.name
									: "",

							stockStakeHolderType:
								stakeholderData.stockStakeHolderType !== null &&
								stakeholderData.stockStakeHolderType.id
									? stakeholderData.stockStakeHolderType.id
									: "",

							isActive: stakeholderData.isActive,

							address:
								stakeholderData.address === null ? "" : stakeholderData.address,

							region:
								stakeholderData.region !== null && stakeholderData.region.id
									? stakeholderData.region.id
									: "",
							regionName:
								stakeholderData.region !== null && stakeholderData.region.name
									? stakeholderData.region.name
									: "",

							zoneIds:
								stakeholderData.zoneIds === null ? "" : stakeholderData.zoneIds,

							areaIds:
								stakeholderData.areaIds === null ? "" : stakeholderData.areaIds,
						};
						return stakeholderByAreaObject;
					});
					dispatch(stockStakeHoldersByAreaSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getStockholderByAreaIdsForFilterPost =
	({ areaIds }) =>
	async (dispatch) => {
		try {
			const response = apiPost({
				url: URL + "/by-areas-new",
				postBody: areaIds,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((stakeholderData, index) => {
						let stakeholderByAreaObject = {
							index: index + 1,
							id: stakeholderData.id === null ? "" : stakeholderData.id,

							userName:
								stakeholderData.userName === null
									? ""
									: stakeholderData.userName,
							firmName:
								stakeholderData.firmName === null
									? ""
									: stakeholderData.firmName,
							ownerName:
								stakeholderData.ownerName === null
									? ""
									: stakeholderData.ownerName,
							name:
								stakeholderData.ownerName === null &&
								stakeholderData.firmName === null
									? ""
									: stakeholderData.firmName +
										" - " +
										stakeholderData.ownerName,

							orderTo:
								//stakeholderData.orderTo === null ? "" : stakeholderData.orderTo,
								stakeholderData.orderTo == null
									? ""
									: stakeholderData.orderTo == 0
										? "Admin"
										: "-",
							orderToName:
								stakeholderData.orderToFirmName !== null
									? stakeholderData.orderToFirmName
									: "",
							state:
								stakeholderData.stateId !== null ? stakeholderData.stateId : "",
							stateName:
								stakeholderData.stateNames !== null
									? stakeholderData.stateNames
									: "",
							areaNames:
								stakeholderData.areaNames === null
									? ""
									: stakeholderData.areaNames,
							shCode:
								stakeholderData.shCode === null ? "" : stakeholderData.shCode,
							contactPersonName:
								stakeholderData.contactPersonName === null
									? ""
									: stakeholderData.contactPersonName,
							contactPersonNo:
								stakeholderData.contactPersonNo === null
									? ""
									: stakeholderData.contactPersonNo,
							emailId:
								stakeholderData.emailId === null ? "" : stakeholderData.emailId,
							stockStakeHolderTypeName:
								stakeholderData.stockStakeHolderTypeName !== null
									? stakeholderData.stockStakeHolderTypeName
									: "",

							stockStakeHolderType:
								stakeholderData.stockStakeHolderTypeId !== null
									? stakeholderData.stockStakeHolderTypeId
									: "",

							isActive: stakeholderData.isActive,

							address:
								stakeholderData.address === null ? "" : stakeholderData.address,

							region: stakeholderData.regionId ? stakeholderData.regionId : "",
							regionName: stakeholderData.regionName
								? stakeholderData.regionName
								: "",

							zoneIds:
								stakeholderData.zoneIds === null ? "" : stakeholderData.zoneIds,

							areaIds:
								stakeholderData.areaIds === null ? "" : stakeholderData.areaIds,
						};
						return stakeholderByAreaObject;
					});
					dispatch(stakeHolderSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getStakeHolderNameByStakeholderTypeAndArea =
	({ type, areaIds }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url: URL + "/by-type-and-area-ids?type=" + type + "&areaIds=" + areaIds,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((stakeHolderTypeObj, index) => {
						const stakeHolderTypeData = {
							index: index + 1,
							...stakeHolderTypeObj,
							name:
								stakeHolderTypeObj.ownerName !== null &&
								stakeHolderTypeObj.firmName &&
								stakeHolderTypeObj.ownerName &&
								stakeHolderTypeObj.firmName
									? stakeHolderTypeObj.firmName +
										"" +
										"(" +
										stakeHolderTypeObj.ownerName +
										")"
									: "",
						};
						return stakeHolderTypeData;
					});
					dispatch(stakeHolderNameFromTypeSuccess({ row: row }));
					return { response: [], success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getStakeHolderNameByStakeholderTypeAndAreaPost =
	({ jsonData }) =>
	async (dispatch) => {
		try {
			const response = apiPost({
				url: URL + "/by-stock-stake-holder-type-and-areas",
				postBody: jsonData,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((stakeHolderTypeObj, index) => {
						const stakeHolderTypeData = {
							index: index + 1,
							...stakeHolderTypeObj,
							name:
								stakeHolderTypeObj.ownerName !== null &&
								stakeHolderTypeObj.firmName &&
								stakeHolderTypeObj.ownerName &&
								stakeHolderTypeObj.firmName
									? stakeHolderTypeObj.firmName +
										"" +
										"(" +
										stakeHolderTypeObj.ownerName +
										")"
									: "",
						};
						return stakeHolderTypeData;
					});
					dispatch(stakeHolderNameFromTypeSuccess({ row: row }));
					return { response: [], success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getStakeHolderNameByStakeholderTypeAndAreaPostNew =
	({ jsonData }) =>
	async (dispatch) => {
		try {
			const response = apiPost({
				url: URL + "/get-by-stock-stake-holder-types-and-areas",
				postBody: jsonData,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((stakeHolderTypeObj, index) => {
						const stakeHolderTypeData = {
							index: index + 1,
							...stakeHolderTypeObj,
							name:
								stakeHolderTypeObj.ownerName !== null &&
								stakeHolderTypeObj.firmName &&
								stakeHolderTypeObj.ownerName &&
								stakeHolderTypeObj.firmName
									? stakeHolderTypeObj.firmName +
										"" +
										"(" +
										stakeHolderTypeObj.ownerName +
										")"
									: "",
						};
						return stakeHolderTypeData;
					});
					dispatch(stakeHolderNameFromTypeSuccess({ row: row }));
					return { response: [], success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getInActiveStakeHolderNameByStakeholderTypeAndAreaPost =
	({ jsonData }) =>
	async (dispatch) => {
		try {
			const response = apiPost({
				url: URL + "/inactive-stock-stake-holder-by-type-and-areas",
				postBody: jsonData,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((stakeHolderTypeObj, index) => {
						const stakeHolderTypeData = {
							index: index + 1,
							...stakeHolderTypeObj,
							name:
								stakeHolderTypeObj.ownerName !== null &&
								stakeHolderTypeObj.firmName &&
								stakeHolderTypeObj.ownerName &&
								stakeHolderTypeObj.firmName
									? stakeHolderTypeObj.firmName +
										"" +
										"(" +
										stakeHolderTypeObj.ownerName +
										")"
									: "",
						};
						return stakeHolderTypeData;
					});
					dispatch(stakeHolderNameFromTypeSuccess({ row: row }));
					return { response: [], success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getInActiveStockStakeHolder =
	({ jsonData }) =>
	async (dispatch) => {
		try {
			const response = apiPost({
				url: URL + "/inactive-stock-stake-holder-by-type",
				postBody: jsonData,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((stakeHolderTypeObj, index) => {
						const stakeHolderTypeData = {
							index: index + 1,
							...stakeHolderTypeObj,
							name:
								stakeHolderTypeObj.ownerName !== null &&
								stakeHolderTypeObj.firmName &&
								stakeHolderTypeObj.ownerName &&
								stakeHolderTypeObj.firmName
									? stakeHolderTypeObj.firmName +
										"" +
										"(" +
										stakeHolderTypeObj.ownerName +
										")"
									: "",
						};
						return stakeHolderTypeData;
					});
					dispatch(stakeHolderNameFromTypeSuccess({ row: row }));
					return { response: [], success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getStakeHolderNameByStakeholderTypeAndAreaUpdated =
	({ stockStakeHolderTypeIds, areaIds, transporterId }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url:
					URL +
					"/by-stock-stake-holder-types-and-areas?stockStakeHolderTypeIds=" +
					stockStakeHolderTypeIds +
					"&areaIds=" +
					areaIds +
					"&transporterId=" +
					transporterId,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((stakeHolderTypeObj, index) => {
						const stakeHolderTypeData = {
							index: index + 1,
							...stakeHolderTypeObj,
							name:
								stakeHolderTypeObj.ownerName !== null &&
								stakeHolderTypeObj.firmName &&
								stakeHolderTypeObj.ownerName &&
								stakeHolderTypeObj.firmName
									? stakeHolderTypeObj.firmName +
										"" +
										"(" +
										stakeHolderTypeObj.ownerName +
										")"
									: "",
						};
						return stakeHolderTypeData;
					});
					dispatch(stakeHolderNameFromTypeSuccess({ row: row }));
					return { response: [], success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const setStakeHolderNameByStakeholderTypeAndArea =
	({ row }) =>
	async (dispatch) => {
		dispatch(stakeHolderNameFromTypeSuccess({ row }));
	};
export const getAreaByDistrictPost =
	({ areaDataForPost }) =>
	async (dispatch) => {
		try {
			const response = apiPost({
				url: URL + "/get-areas-by-zones-districts",
				postBody: areaDataForPost,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((areaObject, index) => {
						let areaPostData = {
							index: index + 1,
							id: areaObject.id === null ? "" : areaObject.id,
							name:
								areaObject.name === null
									? ""
									: areaObject.name + " (" + areaObject.shortName + ")",
							taluka: areaObject.taluka === null ? "" : areaObject.taluka,
							zone:
								areaObject.taluka !== null &&
								areaObject.taluka.district !== null &&
								areaObject.taluka.district.zone !== null &&
								areaObject.taluka.district.zone.id
									? areaObject.taluka.district.zone.id
									: "",
							zoneName:
								areaObject.taluka !== null &&
								areaObject.taluka.district !== null &&
								areaObject.taluka.district.zone !== null &&
								areaObject.taluka.district.zone.name
									? areaObject.taluka.district.zone.name
									: "",

							shortName:
								areaObject.shortName === null ? "" : areaObject.shortName,
							sortOrder:
								areaObject.sortOrder === null ? "" : areaObject.sortOrder,
						};

						return areaPostData;
					});
					dispatch(areaByDistrictPostSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getAreaByDistrictPostNew =
	({ areaDataForPost }) =>
	async (dispatch) => {
		try {
			const response = apiPost({
				url: URL + "/get-areas-by-zones-districts-new",
				postBody: areaDataForPost,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((areaObject, index) => {
						let areaPostData = {
							index: index + 1,
							id: areaObject.id === null ? "" : areaObject.id,
							name:
								areaObject.name === null
									? ""
									: areaObject.name + " (" + areaObject.shortName + ")",
							taluka: areaObject.taluka === null ? "" : areaObject.taluka,
							zone:
								areaObject.taluka !== null &&
								areaObject.taluka.district !== null &&
								areaObject.taluka.district.zone !== null &&
								areaObject.taluka.district.zone.id
									? areaObject.taluka.district.zone.id
									: "",
							zoneName:
								areaObject.taluka !== null &&
								areaObject.taluka.district !== null &&
								areaObject.taluka.district.zone !== null &&
								areaObject.taluka.district.zone.name
									? areaObject.taluka.district.zone.name
									: "",

							shortName:
								areaObject.shortName === null ? "" : areaObject.shortName,
							sortOrder:
								areaObject.sortOrder === null ? "" : areaObject.sortOrder,
						};

						return areaPostData;
					});
					dispatch(areaByDistrictPostSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getOpeningList = () => async (dispatch) => {
	try {
		const response = await apiGet({ url: URL3 + "/get-all" });

		if (response.success) {
			console.log("data", response.data);

			const row = response.data.data.map((stakeHolderTypeObj, index) => ({
				index: index + 1,
				stockStakeHolderId: stakeHolderTypeObj.id || "",
				id: stakeHolderTypeObj.id || "",
				name: stakeHolderTypeObj.stockStakeHolderFirmName || "",
				date: stakeHolderTypeObj.date || "",
				amount: stakeHolderTypeObj.totalAmt
					? Number(stakeHolderTypeObj.totalAmt).toFixed(2)
					: "0.00",
				type: stakeHolderTypeObj.type === 0 ? "Credit" : "Debit",
			}));

			console.log("row", row);

			dispatch(openingSuccess({ row }));

			return { response: row, success: true };
		}

		return { response: [], success: false };
	} catch (e) {
		console.error("API Error:", e.message);
		return { response: [], success: false };
	}
};

export const getOpeningOutletList = () => async (dispatch) => {
	try {
		const response = await apiGet({ url: URL4 + "/get-all" });

		if (response.success) {
			console.log("data", response.data);

			const row = response.data.data.map((stakeHolderTypeObj, index) => ({
				index: index + 1,
				stockStakeHolderId: stakeHolderTypeObj.id || "",
				id: stakeHolderTypeObj.id || "",
				name: stakeHolderTypeObj.outletFirmName || "",
				date: stakeHolderTypeObj.date || "",
				amount: stakeHolderTypeObj.totalAmt
					? Number(stakeHolderTypeObj.totalAmt).toFixed(2)
					: "0.00",
				type: stakeHolderTypeObj.type === 0 ? "Credit" : "Debit",
			}));

			console.log("row", row);

			dispatch(openingSuccess({ row }));

			return { response: row, success: true };
		}

		return { response: [], success: false };
	} catch (e) {
		console.error("API Error:", e.message);
		return { response: [], success: false };
	}
};

export const getStockHoldersByBeats =
	({ beatIds }) =>
	async (dispatch) => {
		try {
			const response = apiPost({
				url: URL + "/by-beats",
				postBody: beatIds,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((stockHolderObject, index) => {
						let stockHolderData = {
							index: index + 1,
							id: stockHolderObject.id === null ? "" : stockHolderObject.id,
							name:
								stockHolderObject.firmName !== null &&
								stockHolderObject.ownerName !== null
									? stockHolderObject.firmName +
										"-" +
										stockHolderObject.ownerName
									: "",
							name:
								stockHolderObject.firmName !== null &&
								stockHolderObject.stockStakeHolderType !== null &&
								stockHolderObject.stockStakeHolderType.name !== null
									? stockHolderObject.firmName +
										" (" +
										stockHolderObject.stockStakeHolderType.name +
										")"
									: "",
							stockStakeHolderType:
								stockHolderObject.stockStakeHolderType === null
									? ""
									: stockHolderObject.stockStakeHolderType,
							shortName:
								stockHolderObject.shortName === null
									? ""
									: stockHolderObject.shortName,
							sortOrder:
								stockHolderObject.sortOrder === null
									? ""
									: stockHolderObject.sortOrder,
						};

						return stockHolderData;
					});
					dispatch(stockHolderByBeatIdsSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};
export const getStockHolderByBeats =
	({ beatIds }) =>
	async (dispatch) => {
		try {
			const response = apiPost({
				url: URL + "/by-beats",
				postBody: beatIds,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((stakeholderObj, index) => {
						let stakeholderData = {
							index: index + 1,
							id: stakeholderObj.id === null ? "" : stakeholderObj.id,
							name:
								stakeholderObj.firmName !== null &&
								stakeholderObj.stockStakeHolderType !== null &&
								stakeholderObj.stockStakeHolderType.name !== null
									? stakeholderObj.firmName +
										" (" +
										stakeholderObj.stockStakeHolderType.name +
										")"
									: "",
							userName:
								stakeholderObj.userName === null ? "" : stakeholderObj.userName,
							stockStakeHolderType:
								stakeholderObj.stockStakeHolderType !== null &&
								stakeholderObj.stockStakeHolderType.name !== null
									? stakeholderObj.stockStakeHolderType.name
									: "",
						};
						return stakeholderData;
					});
					dispatch(stakeHolderSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getStockHoldersByNotAssignStructureWithOutletCount =
	() => async (dispatch) => {
		try {
			const response = apiGet({
				url: URL + "/by-not-assign-rate-structure-with-outlet-count",
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((stockHolderObject, index) => {
						let stockHolderData = {
							index: index + 1,
							id: stockHolderObject.id === null ? "" : stockHolderObject.id,
							name:
								stockHolderObject.firmName !== null &&
								stockHolderObject.stockStakeHolderTypeName !== null
									? stockHolderObject.firmName +
										" (" +
										stockHolderObject.stockStakeHolderTypeName +
										")"
									: "",
							firmName:
								stockHolderObject.firmName === null
									? ""
									: stockHolderObject.firmName,
							stockStakeHolderType:
								stockHolderObject.stockStakeHolderTypeName === null
									? ""
									: stockHolderObject.stockStakeHolderTypeName,
							ownerName:
								stockHolderObject.ownerName === null
									? ""
									: stockHolderObject.ownerName,
							areaName:
								stockHolderObject.areaName === null
									? ""
									: stockHolderObject.areaName,
							outletCount:
								stockHolderObject.outletCount === null
									? ""
									: stockHolderObject.outletCount,
							stockStakeHolderTypeId:
								stockHolderObject.stockStakeHolderTypeId === null
									? ""
									: stockHolderObject.stockStakeHolderTypeId,
							stockStakeHolderTypeName:
								stockHolderObject.stockStakeHolderTypeName === null
									? ""
									: stockHolderObject.stockStakeHolderTypeName,
						};
						return stockHolderData;
					});
					dispatch(stockHolderByNoStructureWithOutletCountSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getStockHoldersByAreaIds = () => async (dispatch) => {
	try {
		const response = apiGet({
			url: URL + "/by-user-areas-optimize",
		}).then(({ data, success }) => {
			if (success) {
				const row = data.data.map((stockHolderObject, index) => {
					let stockHolderDataNew = {
						index: index + 1,
						id: stockHolderObject.id === null ? "" : stockHolderObject.id,
						name:
							stockHolderObject.firmName !== null
								? stockHolderObject.firmName +
									" (" +
									stockHolderObject.stockStakeHolderType.prefix +
									")"
								: "",
						stockStakeHolderType:
							stockHolderObject.stockStakeHolderType === null
								? ""
								: stockHolderObject.stockStakeHolderType,
						prefix:
							stockHolderObject.prefix === null ? "" : stockHolderObject.prefix,
						orderTo:
							stockHolderObject.orderTo === null
								? ""
								: stockHolderObject.orderTo,
						orderToName:
							stockHolderObject.orderToName === null
								? ""
								: stockHolderObject.orderToName,
					};
					return stockHolderDataNew;
				});
				dispatch(stakeHolderSuccess({ row }));
				return { response: row, success };
			}
			return { response: [], success };
		});
		return response;
	} catch (e) {
		return console.error(e.message);
	}
};

export const getCreditLimitByStockHolderId =
	({ stockStakeHolderId }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url:
					URL +
					"/get-credit-limit-by-stock-stake-holder?stockStakeHolderId=" +
					stockStakeHolderId,
			}).then(({ data, success }) => {
				if (success) {
					let stockHolderObjectNew = data.data;
					let stockHolderDataCredit = {
						id: stockHolderObjectNew.id === null ? "" : stockHolderObjectNew.id,
						firmName:
							stockHolderObjectNew.firmName === null
								? ""
								: stockHolderObjectNew.firmName,
						stockStakeHolderTypeName:
							stockHolderObjectNew.stockStakeHolderTypeName === null
								? ""
								: stockHolderObjectNew.stockStakeHolderTypeName,
						creditLimit:
							stockHolderObjectNew.creditLimit === null
								? ""
								: stockHolderObjectNew.creditLimit,
					};
					dispatch(creditLimitSuccess({ row: stockHolderDataCredit }));
					return { response: stockHolderDataCredit, success };
				}
				return { response: {}, success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getSalesDataByMonth =
	({ monthYear }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url: URL + "/sales-data-by-month?monthYear=" + monthYear,
			}).then(({ data, success }) => {
				if (success) {
					const salesObj = data.data;
					console.log(salesObj);
					const salesData = {
						currentMonthSalesAmtPrimary:
							salesObj.currentMonthSalesAmtPrimary === null
								? ""
								: salesObj.currentMonthSalesAmtPrimary,
						currentMonthOrderAmtPrimary:
							salesObj.currentMonthOrderAmtPrimary === null
								? ""
								: salesObj.currentMonthOrderAmtPrimary,
						currentMonthSalesAmtSecondary:
							salesObj.currentMonthSalesAmtSecondary === null
								? ""
								: salesObj.currentMonthSalesAmtSecondary,
						currentMonthOrderAmtSecondary:
							salesObj.currentMonthOrderAmtSecondary === null
								? ""
								: salesObj.currentMonthOrderAmtSecondary,
						grnAmt: salesObj.grnAmt === null ? "" : salesObj.grnAmt,
						crnAmt: salesObj.crnAmt === null ? "" : salesObj.crnAmt,
						selfCrnAmt: salesObj.crnAmt === null ? "" : salesObj.selfCrnAmt,
						outletCrnAmt:
							salesObj.outletCrnAmt === null ? "" : salesObj.outletCrnAmt,
					};
					dispatch(salesDataByMonthSuccess({ salesData }));
					return { response: salesData, success };
				}
				return { response: {}, success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getSalesDataByDate =
	({ date }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url: URL + "/sales-data-by-date?date=" + date,
			}).then(({ data, success }) => {
				if (success) {
					const salesDateObj = data.data;
					const salesDataNew = {
						currentMonthSalesAmtPrimary:
							salesDateObj.currentMonthSalesAmtPrimary === null
								? ""
								: salesDateObj.currentMonthSalesAmtPrimary,
						currentMonthOrderAmtPrimary:
							salesDateObj.currentMonthOrderAmtPrimary === null
								? ""
								: salesDateObj.currentMonthOrderAmtPrimary,
						currentMonthSalesAmtSecondary:
							salesDateObj.currentMonthSalesAmtSecondary === null
								? ""
								: salesDateObj.currentMonthSalesAmtSecondary,
						currentMonthOrderAmtSecondary:
							salesDateObj.currentMonthOrderAmtSecondary === null
								? ""
								: salesDateObj.currentMonthOrderAmtSecondary,
						grnAmt: salesDateObj.grnAmt === null ? "" : salesDateObj.grnAmt,
						crnAmt: salesDateObj.crnAmt === null ? "" : salesDateObj.crnAmt,
						selfCrnAmt:
							salesDateObj.crnAmt === null ? "" : salesDateObj.selfCrnAmt,
						outletCrnAmt:
							salesDateObj.outletCrnAmt === null
								? ""
								: salesDateObj.outletCrnAmt,
					};
					dispatch(salesDataByDateSuccess({ salesDataNew }));
					return { response: salesDataNew, success };
				}
				return { response: {}, success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getPendingBills =
	({ monthYear }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url: URL + "/pending-bills?monthYear=" + monthYear,
			}).then(({ data, success }) => {
				if (success) {
					const pendingBillsObj = data.data;

					const pendingData = {
						currentMonthPendingBillsPrimary:
							pendingBillsObj.currentMonthPendingBillsPrimary === null
								? ""
								: pendingBillsObj.currentMonthPendingBillsPrimary.map(
										(primaryObj, index) => {
											return {
												index: index + 1,
												id: primaryObj.id === null ? "" : primaryObj.id,
												orderDate:
													primaryObj.orderDate === null
														? ""
														: primaryObj.orderDate,
												orderNo:
													primaryObj.orderNo === null ? "" : primaryObj.orderNo,
												fromOrder:
													primaryObj.fromOrder === null
														? ""
														: primaryObj.fromOrder,
												toOrder:
													primaryObj.toOrder === null ? "" : primaryObj.toOrder,

												fromOrderFirmName:
													primaryObj.fromOrderFirmName === null
														? ""
														: primaryObj.fromOrderFirmName,
												toOrderFirmName:
													primaryObj.toOrderFirmName === null
														? ""
														: primaryObj.toOrderFirmName,
												taxableAmt:
													primaryObj.taxableAmt === null
														? ""
														: primaryObj.taxableAmt.toFixed(2),

												cgstAmt:
													primaryObj.cgstAmt === null
														? ""
														: primaryObj.cgstAmt.toFixed(2),
												sgstAmt:
													primaryObj.sgstAmt === null
														? ""
														: primaryObj.sgstAmt.toFixed(2),
												igstAmt:
													primaryObj.igstAmt === null
														? ""
														: primaryObj.igstAmt.toFixed(2),
												totalTax: (
													(primaryObj.cgstAmt === null
														? ""
														: primaryObj.cgstAmt) +
													(primaryObj.sgstAmt === null
														? ""
														: primaryObj.sgstAmt) +
													(primaryObj.igstAmt === null
														? ""
														: primaryObj.igstAmt)
												).toFixed(2),

												totalAmt:
													primaryObj.totalAmt === null
														? ""
														: primaryObj.totalAmt.toFixed(2),
												status:
													primaryObj.status === null ? "" : primaryObj.status,
											};
										},
									),
					};

					const pendingDataSecondary = {
						currentMonthPendingBillsSecondary:
							pendingBillsObj.currentMonthPendingBillsSecondary === null
								? ""
								: pendingBillsObj.currentMonthPendingBillsSecondary.map(
										(secondaryObj, index) => {
											return {
												index: index + 1,
												id: secondaryObj.id === null ? "" : secondaryObj.id,
												orderDate:
													secondaryObj.orderDate === null
														? ""
														: secondaryObj.orderDate,
												orderNo:
													secondaryObj.orderNo === null
														? ""
														: secondaryObj.orderNo,
												outletId:
													secondaryObj.outletId === null
														? ""
														: secondaryObj.outletId,
												outletFirmName:
													secondaryObj.outletFirmName === null
														? ""
														: secondaryObj.outletFirmName,
												toOrderFirmName:
													secondaryObj.toOrderFirmName === null
														? ""
														: secondaryObj.toOrderFirmName,
												insertedUserPersonName:
													secondaryObj.insertedUserPersonName === null
														? ""
														: secondaryObj.insertedUserPersonName,
												taxableAmt:
													secondaryObj.taxableAmt === null
														? ""
														: secondaryObj.taxableAmt.toFixed(2),
												distcountAmt:
													secondaryObj.distcountAmt === null
														? ""
														: secondaryObj.distcountAmt.toFixed(2),

												cgstAmt:
													secondaryObj.cgstAmt === null
														? ""
														: secondaryObj.cgstAmt.toFixed(2),
												sgstAmt:
													secondaryObj.sgstAmt === null
														? ""
														: secondaryObj.sgstAmt.toFixed(2),
												igstAmt:
													secondaryObj.igstAmt === null
														? ""
														: secondaryObj.igstAmt.toFixed(2),
												totalTax: (
													(secondaryObj.cgstAmt === null
														? ""
														: secondaryObj.cgstAmt) +
													(secondaryObj.sgstAmt === null
														? ""
														: secondaryObj.sgstAmt) +
													(secondaryObj.igstAmt === null
														? ""
														: secondaryObj.igstAmt)
												).toFixed(2),
												totalAmt:
													secondaryObj.totalAmt === null
														? ""
														: secondaryObj.totalAmt.toFixed(2),
											};
										},
									),
					};

					const finalData = {
						...pendingData,
						...pendingDataSecondary,
					};

					dispatch(pendingDataSuccess({ row: finalData }));
					return { response: finalData, success };
				}

				return { response: {}, success };
			});
			return response;
		} catch (e) {
			console.error(e.message);
			return { response: {}, success: false };
		}
	};

export const getTopPerformingEntities =
	({ monthYear }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url: URL + "/top-performing-entities?monthYear=" + monthYear,
			}).then(({ data, success }) => {
				if (success) {
					const topPerformingObj = data.data;

					const topPrimaryData = {
						productListPrimary:
							topPerformingObj.productListPrimary === null
								? ""
								: topPerformingObj.productListPrimary.map(
										(primaryObj, index) => {
											return {
												index: index + 1,
												id: primaryObj.id === null ? "" : primaryObj.id,
												name: primaryObj.name === null ? "" : primaryObj.name,
												shortName:
													primaryObj.shortName === null
														? ""
														: primaryObj.shortName,
												categoryName:
													primaryObj.categoryName === null
														? ""
														: primaryObj.categoryName,
												subCategoryName:
													primaryObj.subCategoryName === null
														? ""
														: primaryObj.subCategoryName,
												weight:
													primaryObj.weight === null ? "" : primaryObj.weight,
												description:
													primaryObj.description === null
														? ""
														: primaryObj.description,
												selfLife:
													primaryObj.selfLife === null
														? ""
														: primaryObj.selfLife,
												sortOrder:
													primaryObj.sortOrder === null
														? ""
														: primaryObj.sortOrder,
												isActive:
													primaryObj.isActive === null
														? ""
														: primaryObj.isActive,
												totalQty:
													primaryObj.totalQty === null
														? ""
														: primaryObj.totalQty.toFixed(2),
												totalAmt:
													primaryObj.totalAmt === null
														? ""
														: primaryObj.totalAmt.toFixed(2),

												qtyStdUnit:
													primaryObj.qtyStdUnit === null
														? ""
														: primaryObj.qtyStdUnit.toFixed(2),
												insertDateTime:
													primaryObj.insertDateTime === null
														? ""
														: primaryObj.insertDateTime,
											};
										},
									),
					};

					const topSecondaryData = {
						productListSecondary:
							topPerformingObj.productListSecondary === null
								? ""
								: topPerformingObj.productListSecondary.map(
										(secondaryObj, index) => {
											return {
												index: index + 1,
												id: secondaryObj.id === null ? "" : secondaryObj.id,
												name:
													secondaryObj.name === null ? "" : secondaryObj.name,
												shortName:
													secondaryObj.shortName === null
														? ""
														: secondaryObj.shortName,
												weight:
													secondaryObj.weight === null
														? ""
														: secondaryObj.weight,
												categoryName:
													secondaryObj.categoryName === null
														? ""
														: secondaryObj.categoryName,
												subCategoryName:
													secondaryObj.subCategoryName === null
														? ""
														: secondaryObj.subCategoryName,
												description:
													secondaryObj.description === null
														? ""
														: secondaryObj.description,
												selfLife:
													secondaryObj.selfLife === null
														? ""
														: secondaryObj.selfLife,
												sortOrder:
													secondaryObj.sortOrder === null
														? ""
														: secondaryObj.sortOrder,
												isActive:
													secondaryObj.isActive === null
														? ""
														: secondaryObj.isActive,
												totalQty:
													secondaryObj.totalQty === null
														? ""
														: secondaryObj.totalQty.toFixed(2),
												totalAmt:
													secondaryObj.totalAmt === null
														? ""
														: secondaryObj.totalAmt.toFixed(2),

												qtyStdUnit:
													secondaryObj.qtyStdUnit === null
														? ""
														: secondaryObj.qtyStdUnit.toFixed(2),
												insertDateTime:
													secondaryObj.insertDateTime === null
														? ""
														: secondaryObj.insertDateTime,
											};
										},
									),
					};

					const topStakeHoldersData = {
						stockStakeHolders:
							topPerformingObj.stockStakeHolders === null
								? ""
								: topPerformingObj.stockStakeHolders.map(
										(stockHolderObj, index) => {
											return {
												index: index + 1,
												id: stockHolderObj.id === null ? "" : stockHolderObj.id,
												// name: stockHolderObj.name === null ? "" : stockHolderObj.name,
												// name : stockHolderObj.stockStakeHolderType === null ? "" : stockHolderObj.stockStakeHolderType,
												name:
													stockHolderObj.stockStakeHolderType === null
														? ""
														: stockHolderObj.stockStakeHolderType.name === null
															? ""
															: stockHolderObj.stockStakeHolderType.name,
												prefix:
													stockHolderObj.stockStakeHolderType === null
														? ""
														: stockHolderObj.stockStakeHolderType.prefix ===
															  null
															? ""
															: stockHolderObj.stockStakeHolderType.prefix,
												firmName:
													stockHolderObj.firmName === null
														? ""
														: stockHolderObj.firmName,
												count:
													stockHolderObj.stockStakeHolderType === null
														? ""
														: stockHolderObj.stockStakeHolderType.count === null
															? ""
															: stockHolderObj.stockStakeHolderType.count,
												ownerName:
													stockHolderObj.ownerName === null
														? ""
														: stockHolderObj.ownerName,
												areaNames:
													stockHolderObj.areaNames === null
														? ""
														: stockHolderObj.areaNames,
												totalOrder:
													stockHolderObj.totalOrder === null
														? ""
														: stockHolderObj.totalOrder.toFixed(2),

												contactPersonName:
													stockHolderObj.contactPersonName === null
														? ""
														: stockHolderObj.contactPersonName,
												contactPersonNo:
													stockHolderObj.contactPersonNo === null
														? ""
														: stockHolderObj.contactPersonNo,
											};
										},
									),
					};

					const topoutletListData = {
						outletList:
							topPerformingObj.outletList === null
								? ""
								: topPerformingObj.outletList.map((outletObj, index) => {
										return {
											index: index + 1,
											id: outletObj.id === null ? "" : outletObj.id,
											firmName:
												outletObj.firmName === null ? "" : outletObj.firmName,
											ownerName:
												outletObj.ownerName === null ? "" : outletObj.ownerName,
											beatName:
												outletObj.beatName === null ? "" : outletObj.beatName,
											mobileNo:
												outletObj.mobileNo === null ? "" : outletObj.mobileNo,
											beatId: outletObj.beatId === null ? "" : outletObj.beatId,
											outstandingAmt:
												outletObj.outstandingAmt === null
													? ""
													: outletObj.outstandingAmt.toFixed(2),
											crnTotalAmt:
												outletObj.crnTotalAmt === null
													? ""
													: outletObj.crnTotalAmt.toFixed(2),
											paymentReceiptTotalAmt:
												outletObj.paymentReceiptTotalAmt === null
													? ""
													: outletObj.paymentReceiptTotalAmt.toFixed(2),
											totalAmt:
												outletObj.totalAmt === null
													? ""
													: outletObj.totalAmt.toFixed(2),
										};
									}),
					};

					const finalDataList = {
						...topPrimaryData,
						...topSecondaryData,
						...topStakeHoldersData,
						...topoutletListData,
					};

					dispatch(productListSuccess({ row: finalDataList }));
					return { response: finalDataList, success };
				}

				return { response: {}, success };
			});
			return response;
		} catch (e) {
			console.error(e.message);
			return { response: {}, success: false };
		}
	};

export const getStockHolerAnalytics =
	({ fromDate, toDate, stockStakeHolderId }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url:
					URL +
					"/wise-analytics?fromDate=" +
					fromDate +
					"&toDate=" +
					toDate +
					"&stockStakeHolderId=" +
					stockStakeHolderId,
			}).then(({ data, success }) => {
				if (success) {
					let stockHolderObjectNew = data.data;
					let stockHolderListObj = {
						billList:
							stockHolderObjectNew.billList !== null
								? stockHolderObjectNew.billList.map((bullListObj, index) => {
										let billListData = {
											index: index + 1,
											id: bullListObj.id !== null ? bullListObj.id : "",
											billNo:
												bullListObj.billNo !== null ? bullListObj.billNo : "",
											date: bullListObj.date !== null ? bullListObj.date : "",
											outletId:
												bullListObj.outletId !== null
													? bullListObj.outletId
													: "",
											outletName:
												bullListObj.outletName !== null
													? bullListObj.outletName
													: "",
											beatId:
												bullListObj.beatId !== null ? bullListObj.beatId : "",
											beatName:
												bullListObj.beatName !== null
													? bullListObj.beatName
													: "",
											areaId:
												bullListObj.areaId !== null ? bullListObj.areaId : "",
											areaName:
												bullListObj.areaName !== null
													? bullListObj.areaName
													: "",
											totalAmt:
												bullListObj.totalAmt !== null
													? bullListObj.totalAmt
													: "",
										};
										return billListData;
									})
								: [],

						timeLine:
							stockHolderObjectNew.timeLine !== null
								? stockHolderObjectNew.timeLine.map((timeLineObj, index) => {
										let timeLineData = {
											index: index + 1,
											id: timeLineObj.id !== null ? timeLineObj.id : "",
											date: timeLineObj.date !== null ? timeLineObj.date : "",
											orderAmt:
												timeLineObj.orderAmt !== null
													? timeLineObj.orderAmt
													: "",
											billAmt:
												timeLineObj.billAmt !== null ? timeLineObj.billAmt : "",
										};
										return timeLineData;
									})
								: [],

						orderList:
							stockHolderObjectNew.orderList !== null
								? stockHolderObjectNew.orderList.map((orderListObj, index) => {
										let orderListData = {
											index: index + 1,
											id: orderListObj.id !== null ? orderListObj.id : "",
											orderNo:
												orderListObj.orderNo !== null
													? orderListObj.orderNo
													: "",
											date: orderListObj.date !== null ? orderListObj.date : "",
											outletId:
												orderListObj.outletId !== null
													? orderListObj.outletId
													: "",
											outletName:
												orderListObj.outletName !== null
													? orderListObj.outletName
													: "",
											beatId:
												orderListObj.beatId !== null ? orderListObj.beatId : "",
											beatName:
												orderListObj.beatName !== null
													? orderListObj.beatName
													: "",
											areaId:
												orderListObj.areaId !== null ? orderListObj.areaId : "",
											areaName:
												orderListObj.areaName !== null
													? orderListObj.areaName
													: "",
											totalAmt:
												orderListObj.totalAmt !== null
													? orderListObj.totalAmt
													: "",
										};
										return orderListData;
									})
								: [],

						lostOrderList:
							stockHolderObjectNew.lostOrderList !== null
								? stockHolderObjectNew.lostOrderList.map(
										(lostOrderListObj, index) => {
											let lostOrderData = {
												index: index + 1,
												id:
													lostOrderListObj.id !== null
														? lostOrderListObj.id
														: "",
												orderNo:
													lostOrderListObj.orderNo !== null
														? lostOrderListObj.orderNo
														: "",
												orderDate:
													lostOrderListObj.orderDate !== null
														? lostOrderListObj.orderDate
														: "",
												uomConversionValue:
													lostOrderListObj.uomConversionValue !== null
														? lostOrderListObj.uomConversionValue
														: "",
												outletId:
													lostOrderListObj.outletId !== null
														? lostOrderListObj.outletId
														: "",
												outletName:
													lostOrderListObj.outletName !== null
														? lostOrderListObj.outletName
														: "",
												productId:
													lostOrderListObj.productId !== null
														? lostOrderListObj.productId
														: "",
												productName:
													lostOrderListObj.productName !== null
														? lostOrderListObj.productName
														: "",
												beatId:
													lostOrderListObj.beatId !== null
														? lostOrderListObj.beatId
														: "",
												beatName:
													lostOrderListObj.beatName !== null
														? lostOrderListObj.beatName
														: "",
												areaId:
													lostOrderListObj.areaId !== null
														? lostOrderListObj.areaId
														: "",
												areaName:
													lostOrderListObj.areaName !== null
														? lostOrderListObj.areaName
														: "",
												outletOrderHeaderId:
													lostOrderListObj.outletOrderHeaderId !== null
														? lostOrderListObj.outletOrderHeaderId
														: "",
												uomId:
													lostOrderListObj.uomId !== null
														? lostOrderListObj.uomId
														: "",
												uomName:
													lostOrderListObj.uomName !== null
														? lostOrderListObj.uomName
														: "",
												totalAmt:
													lostOrderListObj.totalAmt !== null
														? lostOrderListObj.totalAmt
														: "",
											};
											return lostOrderData;
										},
									)
								: [],

						pendingAmt:
							stockHolderObjectNew.pendingAmt !== null
								? stockHolderObjectNew.pendingAmt.map(
										(lostOrderListObj, index) => {
											let lostOrderData = {
												index: index + 1,
												id:
													lostOrderListObj.id !== null
														? lostOrderListObj.id
														: "",
												billNo:
													lostOrderListObj.billNo !== null
														? lostOrderListObj.billNo
														: "",
												billDate:
													lostOrderListObj.billDate !== null
														? lostOrderListObj.billDate
														: "",
												outletId:
													lostOrderListObj.outletId !== null
														? lostOrderListObj.outletId
														: "",
												outletName:
													lostOrderListObj.outletName !== null
														? lostOrderListObj.outletName
														: "",
												beatId:
													lostOrderListObj.beatId !== null
														? lostOrderListObj.beatId
														: "",
												beatName:
													lostOrderListObj.beatName !== null
														? lostOrderListObj.beatName
														: "",
												areaId:
													lostOrderListObj.areaId !== null
														? lostOrderListObj.areaId
														: "",
												areaName:
													lostOrderListObj.areaName !== null
														? lostOrderListObj.areaName
														: "",
												paymentRecieptAmt:
													lostOrderListObj.paymentRecieptAmt !== null
														? lostOrderListObj.paymentRecieptAmt
														: "",
												paymentRecieptStatus:
													lostOrderListObj.paymentRecieptStatus !== null
														? lostOrderListObj.paymentRecieptStatus
														: "",
												areaId:
													lostOrderListObj.areaId !== null
														? lostOrderListObj.areaId
														: "",
												paymentStatus:
													lostOrderListObj.paymentStatus !== null
														? lostOrderListObj.paymentStatus
														: "",
												transactionNo:
													lostOrderListObj.transactionNo !== null
														? lostOrderListObj.transactionNo
														: "",
												totalAmt:
													lostOrderListObj.totalAmt !== null
														? lostOrderListObj.totalAmt
														: "",
											};
											return lostOrderData;
										},
									)
								: [],
					};
					dispatch(stockHolderAnalyticsSuccess({ row: stockHolderListObj }));
					return { response: stockHolderListObj, success };
				}
				return { response: {}, success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const setStockHolerAnalytics =
	({ row }) =>
	async (dispatch) => {
		dispatch(stockHolderAnalyticsSuccess({ row }));
	};

export const getStockStakeHolderByOutlet =
	({ outletId }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url: URL + "/get-by-outlet?outletId=" + outletId,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((stakeholderObjectNew, index) => {
						let stakeholderDataNew = {
							index: index + 1,
							id:
								stakeholderObjectNew.id === null ? "" : stakeholderObjectNew.id,

							name:
								stakeholderObjectNew.firmName !== null
									? stakeholderObjectNew.firmName +
										" (" +
										stakeholderObjectNew.stockStakeHolderType.prefix +
										")"
									: "",
							userId:
								stakeholderObjectNew.userId === null
									? ""
									: stakeholderObjectNew.userId,
							userName:
								stakeholderObjectNew.userName === null
									? ""
									: stakeholderObjectNew.userName,
							stockStakeHolderType:
								stakeholderObjectNew.stockStakeHolderType !== null &&
								stakeholderObjectNew.stockStakeHolderType.id
									? stakeholderObjectNew.stockStakeHolderType.id
									: "",
							stockStakeHolderTypeName:
								stakeholderObjectNew.stockStakeHolderType !== null &&
								stakeholderObjectNew.stockStakeHolderType.name
									? stakeholderObjectNew.stockStakeHolderType.name
									: "",
							firmName:
								stakeholderObjectNew.firmName === null
									? ""
									: stakeholderObjectNew.firmName,
							ownerName:
								stakeholderObjectNew.ownerName === null
									? ""
									: stakeholderObjectNew.ownerName,
							contactPersonName:
								stakeholderObjectNew.contactPersonName === null
									? ""
									: stakeholderObjectNew.contactPersonName,
							contactPersonNo:
								stakeholderObjectNew.contactPersonNo === null
									? ""
									: stakeholderObjectNew.contactPersonNo,
							address:
								stakeholderObjectNew.address === null
									? ""
									: stakeholderObjectNew.address,
							pincode:
								stakeholderObjectNew.pincode === null
									? ""
									: stakeholderObjectNew.pincode,

							areaIds:
								stakeholderObjectNew.areaIds === null
									? ""
									: stakeholderObjectNew.areaIds,
							areaList:
								stakeholderObjectNew.areaList === null
									? ""
									: stakeholderObjectNew.areaList,
						};
						return stakeholderDataNew;
					});
					dispatch(stockHolderOutletSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};
export const getStockStakeHolderByOrderExist =
	({ stockStakeHolderId }) =>
	async (dispatch) => {
		try {
			const response = apiGet({
				url: URL + "/order-to-exists?stockStakeHolderId=" + stockStakeHolderId,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((stakeholderObjNew, index) => {
						let stakeholderDataExist = {
							index: index + 1,
							id: stakeholderObjNew.id === null ? "" : stakeholderObjNew.id,
							userName:
								stakeholderObjNew.userName === null
									? ""
									: stakeholderObjNew.userName,
							name:
								stakeholderObjNew.ownerName === null
									? ""
									: stakeholderObjNew.ownerName,
							firmName:
								stakeholderObjNew.firmName === null
									? ""
									: stakeholderObjNew.firmName,
							stockStakeHolderTypeName:
								stakeholderObjNew.stockStakeHolderType !== null
									? stakeholderObjNew.stockStakeHolderType.name
									: "",

							contactPersonName:
								stakeholderObjNew.contactPersonName === null
									? ""
									: stakeholderObjNew.contactPersonName,
							contactPersonNo:
								stakeholderObjNew.contactPersonNo === null
									? ""
									: stakeholderObjNew.contactPersonNo,
							address:
								stakeholderObjNew.address === null
									? ""
									: stakeholderObjNew.address,
							pincode:
								stakeholderObjNew.pincode === null
									? ""
									: stakeholderObjNew.pincode,
							isActive:
								stakeholderObjNew.isActive === null
									? ""
									: stakeholderObjNew.isActive,
						};
						return stakeholderDataExist;
					});
					dispatch(stockHolderOrderExistSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getAreaByTalukaPost =
	({ areaDataForPost }) =>
	async (dispatch) => {
		try {
			const response = apiPost({
				url: URL + "/get-areas-by-taluka",
				postBody: areaDataForPost,
			}).then(({ data, success }) => {
				if (success) {
					const row = data.data.map((areaObject, index) => {
						let areaPostData = {
							index: index + 1,
							id: areaObject.id === null ? "" : areaObject.id,
							name:
								areaObject.name === null
									? ""
									: areaObject.name + " (" + areaObject.shortName + ")",
							taluka: areaObject.taluka === null ? "" : areaObject.taluka,
							talukaId:
								areaObject.taluka !== null && areaObject.taluka.id !== null
									? areaObject.taluka.id
									: "",
							zone:
								areaObject.taluka !== null &&
								areaObject.taluka.district !== null &&
								areaObject.taluka.district.zone !== null &&
								areaObject.taluka.district.zone.id
									? areaObject.taluka.district.zone.id
									: "",
							zoneName:
								areaObject.taluka !== null &&
								areaObject.taluka.district !== null &&
								areaObject.taluka.district.zone !== null &&
								areaObject.taluka.district.zone.name
									? areaObject.taluka.district.zone.name
									: "",

							shortName:
								areaObject.shortName === null ? "" : areaObject.shortName,
							sortOrder:
								areaObject.sortOrder === null ? "" : areaObject.sortOrder,
						};

						return areaPostData;
					});
					dispatch(areaByDistrictPostSuccess({ row }));
					return { response: row, success };
				}
				return { response: [], success };
			});
			return response;
		} catch (e) {
			return console.error(e.message);
		}
	};

export const getActiveStockHolder = () => async (dispatch) => {
	try {
		const response = apiGet({
			url: URL + "/get-active",
		}).then(({ data, success }) => {
			if (success) {
				const row = data.data.map((stakeholderData, index) => {
					let stakeholderObject = {
						index: index + 1,
						id: stakeholderData.id === null ? "" : stakeholderData.id,
						userName:
							stakeholderData.userName === null ? "" : stakeholderData.userName,
						firmName:
							stakeholderData.firmName === null ? "" : stakeholderData.firmName,
						ownerName:
							stakeholderData.ownerName === null
								? ""
								: stakeholderData.ownerName,
						name:
							stakeholderData.firmName !== null &&
							stakeholderData.stockStakeHolderTypePrefix !== null
								? stakeholderData.firmName +
									" (" +
									stakeholderData.stockStakeHolderTypePrefix +
									")"
								: "",
						stockStakeHolderTypeId:
							stakeholderData.stockStakeHolderTypeId === null
								? ""
								: stakeholderData.stockStakeHolderTypeId,
						stockStakeHolderTypeName:
							stakeholderData.stockStakeHolderTypeName === null
								? ""
								: stakeholderData.stockStakeHolderTypeName,
						stockStakeHolderTypePrefix:
							stakeholderData.stockStakeHolderTypePrefix === null
								? ""
								: stakeholderData.stockStakeHolderTypePrefix,
					};
					return stakeholderObject;
				});
				dispatch(stakeHolderSuccess({ row }));
				return { response: row, success };
			}
			return { response: [], success };
		});
		return response;
	} catch (e) {
		return console.error(e.message);
	}
};
